<template>
  <div>
    <!-- Form -->
    <div class="mt-2">
      <customer-form :form-data.sync="formData" :loading="isLoading" @submit="onSubmit" />
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import store from '@/store';
import { api } from '@/utils/api';
import CustomerForm from './CustomerForm.vue';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  name: 'CustomerAdd',
  components: {
    CustomerForm,
    ToastificationContent,
  },
  setup(props, { root }) {
    const isLoading = ref(false);
    const formData = ref(null);

    const toast = useToast();

    const businessID = computed(() => store.state.user.businessID);
    const userID = computed(() => store.state.user.userID);

    const onSubmit = async () => {
      console.log('=== Customer Add On Submit', JSON.stringify(formData.value, null, 2));

      isLoading.value = true;

      try {
        // Prepare payload with entity wrapper
        const payload = {
          entity: {
            id: 0,
            businessID: businessID.value,
            code: formData.value.code,
            name: formData.value.name,
            shortName: formData.value.shortName,
            commissionPercent: formData.value.commissionPercent,
            accountID: 0,
            accountTitle: '',
            category: formData.value.category,
            subCategoryID: formData.value.subCategoryID,
            address: formData.value.address,
            province: formData.value.province,
            gstNumber: formData.value.gstNumber.replace(/-/g, ''),
            ntnNumber: formData.value.ntnNumber.replace(/-/g, ''),
            cnicNumber: formData.value.cnicNumber.replace(/-/g, ''),
            contactPerson: formData.value.contactPerson,
            cellNumber: formData.value.cellNumber.replace(/-/g, ''),
            whatsappOrUAN: formData.value.whatsappOrUAN,
            telephoneNumber: '',
            email: formData.value.email,
            website: formData.value.website,
            remarks: '',
            isActive: formData.value.isActive,
          },
        };

        console.log('Payload:', payload);

        // Direct API call
        const response = await api.post(
          `/CustomersFBR/Save/${businessID.value}?userID=${userID.value}`,
          payload
        );

        console.log('=== Customer Add API Response:', response);

        // Show success toast
        toast({
          component: ToastificationContent,
          props: {
            title: 'Success',
            text: 'Customer added successfully',
            variant: 'success',
            icon: 'CheckCircleIcon',
          },
        });

        // Navigate back to customer list using root.$router
        root.$router.push('/apps/fbr-invoice/customer');
      } catch (error) {
        console.error('Error adding customer:', error);

        // Show user-friendly error message
        let errorMessage = 'Error adding customer. Please try again.';

        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        // Show error toast
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            text: errorMessage,
            variant: 'danger',
            icon: 'AlertTriangleIcon',
          },
        });
      } finally {
        isLoading.value = false;
      }
    };

    return {
      isLoading,
      formData,
      onSubmit,
    };
  },
};
</script>

<style lang="scss" scoped>
// Add any custom styles here
</style>
